module.exports = __webpack_public_path__ + "img/55.1e9254ea.svg";